"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Supply = void 0;
const GetSupplyList_1 = require("./GetSupplyList");
const GetSupplyDetails_1 = require("./GetSupplyDetails");
__exportStar(require("./GetSupplyList"), exports);
__exportStar(require("./GetSupplyDetails"), exports);
exports.Supply = {
    GetSupplyList: GetSupplyList_1.GetSupplyList,
    GetSupplyDetails: GetSupplyDetails_1.GetSupplyDetails
};
//# sourceMappingURL=index.js.map